import { Module } from 'vuex';
import { RootState } from 'frontend/types';
import { UserSegmentationBundle } from 'frontend/types/segmentation';

interface UserSegmentationBundleState {
  bundle: UserSegmentationBundle | null;
}

const userSegmentations: Module<UserSegmentationBundleState, RootState> = {
  namespaced: true,
  state: () => ({
    bundle: null,
  }),
  getters: {
    userSegmentations: state => state.bundle,
  },
  mutations: {
    setValue(state: UserSegmentationBundleState, value: UserSegmentationBundle): void {
      state.bundle = value;
    },
  },
  actions: {},
};

export default userSegmentations;
